<template>
  <div class="header_wrap">
    <div class="header">
      <span class="header_logo" @click="movePage('/')"></span>
      <span class="header_search">검색</span>
      <div class="header_tab">
        <button class="back_btn" @click="backEvent()"></button>
        <span class="header_tab_search" v-if="checkSearch()" @click="movePage('/search')"></span>
        <span class="header_tab_menu" @click="openSideModal()"></span>
      </div>
    </div>
    <header-menu-modal></header-menu-modal>
  </div>
</template>

<script>
import HeaderMenuModal from "./modal/HeaderMenuModal";

export default {
  name: "PageHeader",
  mixins: [],
  components: {
    HeaderMenuModal
  },
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    openModal(name) {

      this.$modal.show(name);
    },
    openSideModal() {
      this.$modal.show('header-menu-modal', {scroll: window.pageYOffset});
    },
    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
    backEvent() {
      this.$router.back();
    },
    checkSearch() {
      console.log(this.$route.path)
      if (this.$route.path === '/search') {
        return false;
      } else {
        return true;
      }
    }

  },
  watch: {},
}
</script>

<style scoped>

</style>